import {createSelector} from "reselect";
import {getAvatars, getUser} from "modules/selectors";
import {first} from "lodash";

export const getAvatarImage = createSelector(getAvatars, getUser, (avatars, user) => {
	const avatar = user?.avatar;
	const defaultAvatar = first(avatars);

	if (!avatar) {
		return defaultAvatar?.avatar;
	}

	return avatar;
});
